import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { GetTagCrmResponse } from '../../responses/vendas/get-tag-crm.response';
import { CreateTagCrmResponse } from '../../responses/vendas/create-tag-crm.response';
import { DeleteTagCrmResponse } from '../../responses/vendas/delete-tag-crm.response';
import { TagCrmRequest } from '../../requests/vendas/tag-crm.request';

@Injectable({
    providedIn: 'root',
})
export class TagCrmService extends CommonService {
    // O cadastro migrou de db_vendas para db_crm junto com a tabela tag_crm.
    private readonly apiUrl: string = environment.urlApiCrm + 'TagCrm';

    constructor(private httpClient: HttpClient) {
        super();
    }

    /** `pagina` é base zero, como o TagCrmController. */
    public getAll(descricao: string = '', pagina: number = 0, tamanhoPagina: number = 20): Observable<GetTagCrmResponse> {
        let params = new HttpParams()
            .set('pagina', pagina.toString())
            .set('tamanhoPagina', tamanhoPagina.toString());

        if (descricao) {
            params = params.set('descricao', descricao);
        }

        return this.httpClient
            .get<GetTagCrmResponse>(this.apiUrl, { params, ...this.addHeaderToken() })
            .pipe(catchError(this.handleError));
    }

    public getById(id: number): Observable<CreateTagCrmResponse> {
        const url = `${this.apiUrl}/idTagCrm/${id}`;
        return this.httpClient
            .get<CreateTagCrmResponse>(url, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public create(request: TagCrmRequest): Observable<CreateTagCrmResponse> {
        return this.httpClient
            .post<CreateTagCrmResponse>(this.apiUrl, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public update(id: number, request: TagCrmRequest): Observable<CreateTagCrmResponse> {
        const url = `${this.apiUrl}/idTagCrm/${id}`;
        return this.httpClient
            .put<CreateTagCrmResponse>(url, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public delete(id: number): Observable<DeleteTagCrmResponse> {
        const url = `${this.apiUrl}/idTagCrm/${id}`;
        return this.httpClient
            .delete<DeleteTagCrmResponse>(url, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public deleteBulk(ids: number[]): Observable<DeleteTagCrmResponse> {
        const url = `${this.apiUrl}/bulk-delete`;
        return this.httpClient
            .post<DeleteTagCrmResponse>(url, { ids }, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }
}
